import React from 'react';
export function AnnouncementBar() {
  return <div className="sticky top-0 z-40 bg-black py-2.5 px-4 w-full" data-id="element-14">
      <p className="text-white text-[13px] text-center font-medium" data-id="element-15">
        ⭐ +5.700 dueños urbanos en España ya han recuperado la PAZ en sus
        paseos este mes.
      </p>
    </div>;
}